// Helpers for the "$CAN,<time>,<id>,<rtr>,<data>*<crc>" line format the hub relays
// over TCP and accepts for transmission. The checksum is the XOR of every character
// between the leading "$" and the "*", written as two upper-case hex digits.

export const CAN_STRING_PATTERN =
  /^\$CAN,\d{1,10},[0-9A-Fa-f]{1,8},[01](?:,(?:[0-9A-Fa-f]{2}){1,8})?\*[0-9A-Fa-f]{2}$/;

// The hub parser rejects lines of 50 characters or more.
export const CAN_STRING_MAX_LENGTH = 49;

export const canStringChecksum = line => {
  const star = line.indexOf('*');
  const body = line.slice(1, star === -1 ? line.length : star);
  let checksum = 0;
  for (const char of body) {
    checksum = (checksum ^ char.charCodeAt(0)) & 0xff;
  }
  return checksum.toString(16).toUpperCase().padStart(2, '0');
};

// Recomputes the checksum of one line; appends "*XX" when it is missing.
// Lines that are not CAN strings are returned trimmed but otherwise untouched.
export const fixCanStringChecksum = line => {
  const trimmed = line.trim();
  if (!trimmed.startsWith('$')) {
    return trimmed;
  }
  const star = trimmed.indexOf('*');
  const body = star === -1 ? trimmed : trimmed.slice(0, star);
  return `${body}*${canStringChecksum(body)}`;
};

export const fixCanStringsChecksums = text =>
  text.split(/\r?\n/).map(fixCanStringChecksum).join('\n');

// Splits editor text into validated frames plus per-line errors (1-based line numbers).
export const parseCanStrings = text => {
  const frames = [];
  const errors = [];
  text.split(/\r?\n/).forEach((raw, index) => {
    const line = raw.trim();
    if (!line) {
      return;
    }
    const number = index + 1;
    if (line.length > CAN_STRING_MAX_LENGTH) {
      errors.push({ line: number, message: `longer than ${CAN_STRING_MAX_LENGTH} characters` });
      return;
    }
    if (!CAN_STRING_PATTERN.test(line)) {
      errors.push({ line: number, message: 'not a valid CAN string' });
      return;
    }
    const expected = canStringChecksum(line);
    const actual = line.slice(-2).toUpperCase();
    if (expected !== actual) {
      errors.push({ line: number, message: `checksum is ${actual}, expected ${expected}` });
      return;
    }
    frames.push(line);
  });
  return { frames, errors };
};
